import React from "react";
import styled from "styled-components";

export default styled.h3`

    color: #515151;
    font-size: 32px;
    line-height: 20px;
    font-weight:700;
    
        display: ${(props) => (props.hidden ? "none" : "block")};
`;